import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap flex-column flex-md-row-reverse ml-auto mr-auto mr-md-1 ga-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_date_input = _resolveComponent("v-date-input")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_NumberField = _resolveComponent("NumberField")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    ref: "frmMainClone",
    modelValue: _ctx.valid,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.valid) = $event)),
    "lazy-validation": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "cloneDialog",
        loading: _ctx.loading,
        disabled: _ctx.loading
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6",
                    sm: "6"
                  }, {
                    default: _withCtx(() => [
                      _cache[4] || (_cache[4] = _createElementVNode("label", { class: "input-label" }, [
                        _createTextVNode(" Date "),
                        _createElementVNode("small", { class: "mt-6 error--text" }, "*")
                      ], -1)),
                      _createVNode(_component_v_date_input, {
                        min: _ctx.minDate,
                        "first-day-of-week": "1",
                        rules: [_ctx.rules.required],
                        modelValue: _ctx.timesheetModel.date,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.timesheetModel.date) = $event)),
                        "hide-actions": "",
                        placeholder: "Date",
                        "prepend-icon": ""
                      }, null, 8, ["min", "rules", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6",
                    sm: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_NumberField, {
                        rules: [_ctx.rules.required, _ctx.rules.step, _ctx.rules.notZero],
                        min: "0",
                        max: "10",
                        label: "Effort / Hours",
                        placeholder: "Effort / Hours",
                        modelValue: _ctx.timesheetModel.effort,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.timesheetModel.effort) = $event)),
                        outlined: "",
                        step: "0.25"
                      }, null, 8, ["rules", "modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "action-bottons" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_btn, {
                  class: "tertiary_btn right actionButton",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirm(true)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode("mdi-check")
                      ])),
                      _: 1
                    }),
                    _cache[6] || (_cache[6] = _createTextVNode("Save and Edit "))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  class: "primary_btn right actionButton",
                  onClick: _ctx.confirm
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode("mdi-check")
                      ])),
                      _: 1
                    }),
                    _cache[8] || (_cache[8] = _createTextVNode("Save "))
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_btn, {
                  text: "",
                  class: "secondary_btn right actionButton",
                  onClick: _ctx.cancel
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createTextVNode("mdi-close")
                      ])),
                      _: 1
                    }),
                    _cache[10] || (_cache[10] = _createTextVNode("Cancel"))
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}